module.exports = __webpack_public_path__ + "media/images/icon_lists-ae69bf4fb26c40d2c9b056c55c9153e2.png";